import React from 'react'
import Avatar from '@material-ui/core/Avatar'
import BrokenImage from '@material-ui/icons/BrokenImage'
import { authorizedLink } from 'utils'

export function ImageAvatar(props) {
  const { alt, urls, ...rest } = props
  if(urls && urls.avatar) {
    let imageUrl = authorizedLink(urls.avatar)
    return <Avatar alt={ alt } src={ imageUrl } { ...rest }/>
  }

  return <Avatar alt={ alt } { ...rest }><BrokenImage/></Avatar>
}